<template>
    <div>
        <div class="card mb-5 mb-3">
            <div class="card-header">
                <h3 class="card-title flex-row">
                    <i class="fa fa-list"></i>
                    <span class="card-label fs-3 ms-1">Cấu hình hệ thống</span>
                </h3>
            </div>
            <div class="card-body">
                <el-form :model="formData" label-width="120px" class="config-form">
                    <el-form-item v-for="(config, index) in configs" :key="index" :label="config.cTenHienThi">
                        <el-input :type="config.cInputType" :show-password="config.cInputType=='password'" style="max-width: 400px;" v-model="formData[config.cTenCauHinh]" :placeholder="config.cTenHienThi"></el-input>
                    </el-form-item>
                </el-form>
                <el-button v-if="configs.length > 0" type="primary" @click="updateConfig">Cập nhật</el-button>
            </div>
        </div>

    </div>
</template>
<script>
import { SystemConfig } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";

export default {
    name: 'SystemConfig',
    data() {
        return {
            configs: [],
            formData: []
        }
    },
    methods: {
        async getConfigs() {
            this.store.dispatch(SystemConfig.showConfig).then((res) => {
                if (res.code == 200) {
                    this.configs = res.data;
                    let processData = {};
                    this.configs.forEach((config) => {
                        if (config.cInputType == 'datetime') {
                            processData[config.cTenCauHinh] = moment(config.cGiaTri).format('DD-MM-YYYY HH:mm:ss');
                        } else if (config.cInputType == 'date') {
                            processData[config.cTenCauHinh] = moment(config.cGiaTri).format('DD-MM-YYYY');
                        } else if (config.cInputType == 'time') {
                            processData[config.cTenCauHinh] = moment(config.cGiaTri).format('HH:mm:ss');
                        } else {
                            processData[config.cTenCauHinh] = config.cGiaTri;
                        }
                        this.formData = Object.assign({}, processData);
                    });
                } else {
                    ElMessage.error(res.message);
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        updateConfig() {
            let data =  this.configs.map((config) => {
                return {
                    id: config.id,
                    cTenCauHinh: config.cTenCauHinh,
                    cTenHienThi: config.cTenHienThi,
                    cInputType: config.cInputType,
                    cGhiChu: config.cGhiChu,
                    cGiaTri: this.formData[config.cTenCauHinh],
                }
            });
            this.store.dispatch(SystemConfig.updateConfig, data).then((res) => {
                if (res.code == 200) {
                    ElMessage.success(res.msg);
                    this.getConfigs();
                } else {
                    ElMessage.error(res.msg);
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    },
    async mounted() {
        this.store = await useStore();
        this.getConfigs();
    },

}

</script>